import Vue from 'vue';
import Vuex from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
import { state } from './state';
Vue.use(Vuex);
var store = {
    state: state,
    mutations: mutations,
    actions: actions
};
export default new Vuex.Store(store);
